module.exports = "/_next/static/images/8f97d8f88d5abd9d9b4ad2f13f4e71a7-pj-man-holding-business-card@0.75x.jpg.webp";